<!-- ngView: -->
<div id="contents" role="main" data-ng-view="" class="ng-scope" >
	<div class="progress ng-scope">
		<ul>
			<li class="active"><i class="sp ico_progress1"></i><span class="ng-binding">SELECT PRODUCT</span></li>
			<li><i class="sp ico_progress2"></i><span class="ng-binding">INPUT PERSONAL INFORMATION</span></li>
			<li><i class="sp ico_progress3"></i><span class="ng-binding">MAKE PAYMENT</span></li>
			<li><i class="sp ico_progress4"></i><span class="ng-binding">COMPLETE PAYMENT</span></li>
		</ul>
	</div>
	<!-- ngIf: vm.PATH_COUNTRY === 'au' -->

	<div class="container ng-scope">
		<section class="cards_wrap mb-0 clearfix"
			data-ng-class="{'only': vm.productList.length == 1, 'mt-none': vm.PATH_COUNTRY == 'au', 'clearfix': vm.PATH_COUNTRY == 'au'}">
			<!-- ngIf: vm.PATH_COUNTRY !== 'ph' && vm.PATH_COUNTRY !== 'br' && vm.PATH_COUNTRY !== 'au' && vm.PATH_COUNTRY !== 'in' && vm.PATH_COUNTRY !== 'id' -->
			<!--div class="heading ng-scope"
				data-ng-if="vm.PATH_COUNTRY !== 'ph' &amp;&amp; vm.PATH_COUNTRY !== 'br' &amp;&amp; vm.PATH_COUNTRY !== 'au' &amp;&amp; vm.PATH_COUNTRY !== 'in' &amp;&amp; vm.PATH_COUNTRY !== 'id'">
				<p class="tit"
					data-ng-bind-html="'product.page.msg.01' | translate:{deviceModelId: vm.deviceModelId, deviceModelName: vm.deviceModelName} | htmlSafe">
				</p>
			</div-->
			<!-- end ngIf: vm.PATH_COUNTRY !== 'ph' && vm.PATH_COUNTRY !== 'br' && vm.PATH_COUNTRY !== 'au' && vm.PATH_COUNTRY !== 'in' && vm.PATH_COUNTRY !== 'id' -->

			<div class="cards_area clearfix mb-none">
				<div class="sub-title"><h3>Select Product</h3>
					<p>Protect your product and enroll within 365 days of purchase.</p></div>
				<article class="card-list clearfix">

					<section class="card_bx" *ngFor='let product of products'>
						<div class="inner">
							<p class="type">
								<span class="type_tit">
									<div class="care-logo">
									<img src="./assets/images/scp_icon.png"></div>
									<div class="product-info">
									<span>{{product.SKUDESC}}</span>
                    <ng-container *ngIf="!product.TERM; else forWasherDry">
									    <span class="detail">Additional {{product.TERM}}-months coverage</span>
                    </ng-container>
                    <ng-template #forWasherDry>
                      <span class="detail">
                        Additional {{Number(product.TERM)}}-months coverage on top of 12 months Samsung manufacturer’s standard warranty period (Total {{ Number(product.TERM)/12 +1 }} years of coverage)</span>
                    </ng-template>
								</div>
								</span>
                <ng-container *ngIf="!product.TECHNICIANID; else priceForTechnicianID">
								<strong class="price" >
									${{product.PRICE}}
									<span class="unit">{{product.PAYMENTFREQUENCY}}</span>
									<span class="standard"></span>
								</strong>
                </ng-container>
                <ng-template #priceForTechnicianID>
                  <strong class="price strike-through">
                    ${{product.PRICE}}
                  </strong>
                  <strong class="price" >
                    ${{product.PRICE-product.DISCOUNTAMOUNT}}
                    <span class="unit">{{product.PAYMENTFREQUENCY}}</span>
                    <span class="standard"></span>
                  </strong>
                </ng-template>

							</p>
							<div class="btn_area only">
								<a class="btn btn_type1 actionNext" (click)="onContract(product)">Select and Continue <img src="./assets/images/button-arrow.png"></a>
							</div>
						</div>
					</section>

					<!--
					<section class="card_bx ng-scope" data-ng-class="{'low': vm.PATH_COUNTRY === 'br'}"
						data-ng-repeat="x in vm.productList" data-ng-bind-html="x.productRawDescription | htmlSafe">
						<div class="inner">
							<p class="type">
								<span class="type_tit">
									<span>Mobile - Monthly</span>
									<span class="detail">coverage</span>
								</span>
								<strong class="price">
									$11.99
									<span class="unit">/Month</span>
									<span class="standard"></span>
								</strong>
							</p>
							<div class="btn_area only">
								<a class="btn btn_type1 actionNext" (click)="onContract()">Contract</a>
							</div>
						</div>
					</section>
					<section class="card_bx ng-scope" data-ng-class="{'low': vm.PATH_COUNTRY === 'br'}"
						data-ng-repeat="x in vm.productList" data-ng-bind-html="x.productRawDescription | htmlSafe">
						<div class="inner">
							<p class="type">
								<span class="type_tit">
									<span>Mobile - Upfront</span>
									<span class="detail">24-months coverage</span>
								</span>
								<strong class="price">
									$299.99
									<span class="standard"></span>
								</strong>
							</p>
							<div class="btn_area only">
								<a class="btn btn_type1 actionNext" (click)="onNext()">Next</a>
							</div>
						</div>
					</section>
					-->
				</article>
			</div>

			<section class="flex_bx pr_sum">
				<div class="summary-title"><h3 class="h3">Order Summary</h3></div>
				<ul class="pr_info">
					<!-- ngIf: vm.deviceModelName != '' -->
					<li class="pr_info_detail"><span class="tit">MODEL CODE</span> <span>{{this.shared.modelCode}}</span></li>
					<li class="pr_info_detail"><span class="tit">SERIAL NUMBER</span> <span>{{this.shared.serialNumber}}</span></li>
					<!-- ngIf: vm.serialView -->
					<!-- ngIf: (vm.dateOfPurchase || '') !== '' -->
				</ul>
				<div class="btn_area">
					<a href="#" class="btn btn_type3">Start Over</a>
				</div>
				<!-- ngIf: vm.PATH_COUNTRY === 'au' -->
			</section>
		</section>
		<!-- ngIf: vm.PATH_COUNTRY === 'au' -->
		<!-- ngIf: vm.PATH_COUNTRY === 'id' -->
	</div>
</div>
